import { DateTime } from "luxon";

export default function formatDateTime(value) {
  if (!value) return "any";
  const date = DateTime.fromISO(value);
  return date.toFormat("dd.MM.yyyy HH:mm");
}